export function randomInt(maxExclusive: number): number {
  if (maxExclusive <= 0) return 0;
  if (typeof globalThis.crypto?.getRandomValues === "function") {
    const limit = Math.floor(0xffffffff / maxExclusive) * maxExclusive;
    const buf = new Uint32Array(1);
    let value = limit;
    do {
      globalThis.crypto.getRandomValues(buf);
      value = buf[0]!;
    } while (value >= limit);
    return value % maxExclusive;
  }
  return Math.floor(Math.random() * maxExclusive);
}

export function pickOne<T>(items: T[]): T | null {
  if (!items.length) return null;
  return items[randomInt(items.length)]!;
}

export function shuffle<T>(items: T[]): T[] {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = randomInt(i + 1);
    [copy[i], copy[j]] = [copy[j]!, copy[i]!];
  }
  return copy;
}

export function parseList(raw: string): string[] {
  return raw
    .split(/\r?\n|,/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function dedupe(items: string[]): string[] {
  return Array.from(new Set(items));
}

export function chunkIntoGroups<T>(items: T[], groupCount: number): T[][] {
  const groups: T[][] = Array.from({ length: Math.max(1, groupCount) }, () => []);
  items.forEach((item, i) => {
    groups[i % groups.length]!.push(item);
  });
  return groups;
}

export function groupsBySize<T>(items: T[], size: number): T[][] {
  const count = Math.max(1, Math.ceil(items.length / Math.max(1, size)));
  return chunkIntoGroups(items, count);
}

export function copyText(text: string) {
  if (typeof navigator !== "undefined" && navigator.clipboard) {
    return navigator.clipboard.writeText(text);
  }
  return Promise.resolve();
}

export const DEFAULT_CLASS_LIST = [
  "Ava",
  "Noah",
  "Mia",
  "Liam",
  "Sofia",
  "Ethan",
  "Zara",
  "Omar",
  "Lily",
  "Jonas",
  "Aisha",
  "Marco",
];
